import styled from 'styled-components';

export const CardWrapper = styled.div`
  display: flex;
  grid-gap: 30px;
`;
